import { CustomersTable } from "@/features/customers/customers-table";
import { MigrateFromV1Dialog } from "@/features/migration/migrate-from-v1-dialog";

const CustomersScreen = () => {
  return (
    <div className="p-4">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold">Customers</h1>
        <MigrateFromV1Dialog />
      </div>
      <CustomersTable />
    </div>
  );
};

export default CustomersScreen;
